var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',{class:['page']},[_c('h2',{class:['headline'],domProps:{"innerHTML":_vm._s(_vm.page.title)}}),_vm._v(" "),_c('p',{class:['body-1', 'my-4'],domProps:{"innerHTML":_vm._s(_vm.page.description)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d4ae38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page.vue
// module id = null
// module chunks = 